<template lang="pug">
  .card.height-100
    .card-body
      .columns
        .column.col-3(v-if="collection.cover")
          img.img-responsive(:src="collection.cover")
        .column.text-ellipsis
          .text-bold.text-ellipsis {{ collection.title }}
          .text-ellipsis {{ collection.brief }}
          .text-ellipsis Tipo: #[span.text-bold {{ collection.collectionType | collectionType }}]
          .text-ellipsis
            | Status:
            span.text-bold(:class="status.class")  {{ status.label }}
          .text-ellipsis
            | Código de busca:
            span.text-bold  {{ collection.id }}
          form(@submit.prevent="onSubmit")
            .input-group
              span.input-group-addon.addon-sm Ordem
              input.form-input.input-sm(type="number" min="0" required v-model.number="collection.order")
              button.btn.btn-primary.input-group-btn.btn-sm
                i.fas.fa-check
    .card-footer
      .columns.align-center
        .column
          .text-small Adicionado em #[span.text-bold {{ collection.createdAt | toDate('DD/MM/YYYY') }}]
        .column.col-auto
          a.btn.btn-action.btn-sm.text-error.btn-link.tooltip(
            data-tooltip="Excluir"
            @click="$emit('remove', collection)"
          )
            i.fas.fa-trash-alt
          a.btn.btn-link.btn-sm.tooltip(:class="status.action.class" :data-tooltip="status.action.label" @click="$emit(status.action.event, collection)")
            i(:class="status.action.icon")
          router-link.btn.btn-action.btn-sm.btn-link.tooltip(
            :to="{ name: 'collections.edit', params: { id: collection.id } }"
            data-tooltip="Editar"
          )
            i.fas.fa-edit
</template>

<script>
import api from '@/services/collections'

const status = {
  true: {
    label: 'Ativo',
    class: 'text-success',
    action: {
      event: 'deactivate',
      label: 'Inativar',
      icon: 'fas fa-lock',
      class: ' text-error',
    },
  },
  false: {
    label: 'Inativo',
    class: 'text-error',
    action: {
      event: 'activate',
      label: 'Ativar',
      icon: 'fas fa-lock-open',
      action: 'text-success',
    },
  },
}

export default {
  data() {
    return { loading: false }
  },
  props: {
    collection: { type: Object, required: true },
  },
  computed: {
    status() {
      return status[this.collection.status]
    },
  },
  methods: {
    async onSubmit() {
      const { id, order } = this.collection
      try {
        this.loading = true
        await api.update({ id, order })
        this.$toaster.success('Ordem alterada')
        this.$emit('refresh')
      } catch (e) {
        this.$toaster.error(e.response.data.message)
      } finally {
        this.loading = false
      }
    },
  },
}
</script>

<style lang="stylus" scoped>
.input-group input
  max-width 70px
</style>
